@if (tabs.length > 1) {
  <mat-tab-group (selectedTabChange)="tabChanged($event)" mat-stretch-tabs="false" mat-align-tabs="start">
    @for (tab of tabs; track tab) {
      <mat-tab [label]="tab.title">
        @if (tab.templateName === 'mediaSearch') {
          <ng-container [ngTemplateOutlet]="mediaSearch"></ng-container>
        }
        @if (tab.templateName === 'programMedia') {
          <ng-container [ngTemplateOutlet]="programMedia"></ng-container>
        }
      </mat-tab>
    }
  </mat-tab-group>
}
@if (tabs.length === 1) {
  <ng-container [ngTemplateOutlet]="mediaSearch"></ng-container>
}

<ng-template #mediaSearch>
  <div class="page-container">
    @if (dialogData?.showSearchInput === true && searchType !== undefined) {
      <form [formGroup]="searchForm">
        <mat-form-field class="filter-media" appearance="outline">
          <mat-label>{{ 'generic.search' | translate }}</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input formControlName="query" matInput [placeholder]="'image_search.search.placeholder' | translate">
        </mat-form-field>
      </form>
    }
    <div class="media-search-container">
      @if (( searchResults$ | async ).length > 0) {
        @if (( aggregations$ | async ); as aggregations) {
          <div class="aggregations">
            <form [formGroup]="searchForm">
              @if (aggregations.media_tags && aggregations.media_tags.buckets.length > 0) {
                <div class="filter">
                  <h4>{{ 'image_search.image_tags.title' | translate }}</h4>
                  <mat-selection-list #tag formControlName="media_tags">
                    @for (option of aggregations.media_tags.buckets; track option) {
                      @if (option.key) {
                        <mat-list-option [value]="option.key"
                          [selected]="searchForm.get('media_tags').value.includes(option.key)">
                          <span class="option-media_tags">{{option.key}}&nbsp;<span
                          class="count">({{option.doc_count}})</span></span>
                        </mat-list-option>
                      }
                    }
                  </mat-selection-list>
                </div>
              }
              @if (aggregations.activity_media_tags && aggregations.activity_media_tags.buckets.length > 0) {
                <div class="filter">
                  <h4>{{ 'image_search.activity_tags.title' | translate }}</h4>
                  <mat-selection-list #tag formControlName="activity_media_tags">
                    @for (option of aggregations.activity_media_tags.buckets; track option) {
                      @if (option.key) {
                        <mat-list-option [value]="option.key"
                          [selected]="searchForm.get('activity_media_tags').value.includes(option.key)">
                          <span class="option-activity_media_tags">{{option.key}}&nbsp;<span
                          class="count">({{option.doc_count}})</span></span>
                        </mat-list-option>
                      }
                    }
                  </mat-selection-list>
                </div>
              }
              @if (aggregations.mime_type && aggregations.mime_type.buckets.length > 0) {
                <div class="filter">
                  <h4>{{ 'image_search.type.title' | translate }}</h4>
                  <mat-selection-list #tag formControlName="mime_type">
                    @for (option of aggregations.mime_type.buckets ; track option) {
                      @if (option.key && option.key === 'image/gif') {
                        <mat-list-option  [value]="option.key"
                          [selected]="searchForm.get('mime_type').value.includes(option.key)">
                          <span class="option-mime_type">GIF's&nbsp;<span
                          class="count">({{option.doc_count}})</span></span>
                        </mat-list-option>
                      }
                    }
                  </mat-selection-list>
                </div>
              }
            </form>
          </div>
        }
      }

      <ng-container>
        <div scrollEnd #scrollContainer (endReached)="scrollEndReached(scrollContainer)" class="search-results">
          @if ((searchResults$ | async); as results) {
            @if ((tabs.length === 1) || (currentTabSelected === tabIndexes.mediaSearch)) {
              <ng-container
              [ngTemplateOutlet]="resultsTemplate" [ngTemplateOutletContext]="{ results: results }"></ng-container>
            }
          }
          @if ((loading$ | async)) {
            <div class="spinner-container">
              <mat-spinner>
              </mat-spinner>
            </div>
          }
          @if ((searchResults$ | async).length === 0) {
            <div class="not-found">
              {{ 'image_search.no_results' | translate }}
            </div>
          }
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #programMedia>
  <div class="program-media-container">
    <div class="search-results">
      @if (programMediaIds.length === 0) {
        {{ 'image_search.no_results_for_program' | translate }}
      }
      @if (programMediaIds.length > 0) {
        @if ((tabs.length !== 1) && (currentTabSelected === tabIndexes.programMedia)) {
          <ng-container
          [ngTemplateOutlet]="resultsTemplate" [ngTemplateOutletContext]="{ results: programMediaIds }"></ng-container>
        }
      }
    </div>
  </div>

</ng-template>

<ng-template #resultsTemplate let-results="results">
  <ngx-masonry id="masonry" [options]="{ gutter: 10, transitionDuration: '0', fitWidth: true, horizontalOrder: true }" [updateLayout]="true">
    @for (image of results; track image; let index = $index) {
      <ngxMasonryItem [id]="'media' + image?.uuid" class="masonry-item animated fadeIn">
        @if ((allowedToEdit$ | async)) {
          <button
            class="media-tag-menu"
            mat-icon-button
            [matMenuTriggerFor]="menu"
            [attr.aria-label]="'image_search.media_options.label' | translate">
            <mat-icon>more_vert</mat-icon>
          </button>
        }
        <mat-menu #menu="matMenu">
          <button (click)="detailsOfMediaItem(image)" mat-menu-item>
            <mat-icon>remove_red_eye</mat-icon>
            <span>{{ 'image_search.details.show' | translate }}</span>
          </button>
          <button (click)="deleteMediaItem(image)" mat-menu-item>
            <mat-icon>close</mat-icon>
            <span>{{ 'generic.archive' | translate }}</span>
          </button>
        </mat-menu>
        <app-doenkids-image (click)="imageSelected(image)" [maxWidth]="200" [maxHeight]="400" (loaded)="imageLoaded()" [preview]="!image.mime_type || image.mime_type !== 'image/gif'"
        [mediaItem]="image"></app-doenkids-image>
      </ngxMasonryItem>
    }
  </ngx-masonry>
</ng-template>
